import { EventTrackingFn } from '@opendoor/shared-fe/build/declarations/EventTracking';

import { ErrorCode } from 'src/declarations/ErrorCode';

import {
  CANCEL_MANUAL_ADDRESS_VERIFICATION,
  ERROR_ANSWER,
  ERROR_PAGE,
  HANDLE_EXCEPTION,
  RECEIVE_HUMAN,
  SEND_PASSWORD_SETUP_EMAIL,
  TRACK_EVENT,
} from './actionTypes';
import { ErrorLevel } from './saga';

export function cancelManualAddressVerification(hadInitialAddress: boolean) {
  return {
    payload: { hadInitialAddress },
    type: CANCEL_MANUAL_ADDRESS_VERIFICATION,
  };
}

export type UpdatedAddress = {
  city: string;
  postalCode: string;
  state: string;
  street: string;
  street1?: string;
  unit?: string;
};

export function removeHuman() {
  return {
    payload: { human: null },
    type: RECEIVE_HUMAN,
  };
}

export function sendPasswordSetUpEmail(email: string, redirectUrl: string) {
  return {
    payload: { email, redirectUrl },
    type: SEND_PASSWORD_SETUP_EMAIL,
  };
}

export function errorAnswer(key: string, hasError: boolean, errorMessage?: string) {
  return {
    payload: { key, hasError, errorMessage },
    type: ERROR_ANSWER,
  };
}

export function errorPage(slug: string, errorMessage: string | undefined) {
  return {
    payload: { slug, errorMessage },
    type: ERROR_PAGE,
  };
}

export const trackEvent: EventTrackingFn = (
  category: string,
  action: string,
  label: string,
  extra: Record<string, unknown>,
) => {
  return {
    payload: { category, action, label, extra },
    type: TRACK_EVENT,
  };
};

export function handleException(
  exception: unknown,
  code: ErrorCode,
  level: ErrorLevel,
  metadata?: unknown,
) {
  return {
    payload: { exception, code, level, metadata },
    type: HANDLE_EXCEPTION,
  };
}
